import { h, FunctionalComponent } from '@stencil/core';
import classnames from 'classnames';

interface PriceProps {
    salePrice?: number;
    msrp?: number;
    weight?: string;
    wrapperClass?: any;
}

const Price: FunctionalComponent<PriceProps> = ({ msrp, salePrice, weight, wrapperClass }) => {

    const displayMSRP = msrp && (
        <span class='display-flex text-subdued-lighter margin-left-1'>
            <span class='text-size-200 text-normal'>MSRP </span>
            <span class="text-size-200 margin-left-1">
                {'$' + Number((msrp).toFixed()).toLocaleString()}
            </span>
        </span>
    );

    return (
        <div class={wrapperClass}>
            <span
                class={classnames({
                    'text-size-600': true,
                    'text-bold': !weight,
                    [`text-${weight}`]: weight,
                    'first-price': true,
                })}
            >
                {Number((salePrice || 0).toFixed()).toLocaleString() /* formats commas for US currency and truncates any decimals */}
                {displayMSRP}
            </span>
        </div>
    );
}



export default Price;